module.exports = __webpack_public_path__ + "img/IEC13787.c4cf78fc.png";